import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TextWithShowMoreComponent, TooltipModule } from '@libs/ui-lib';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { ProvisionalStatus } from '@ffd/api-client';
import { Store } from '@ngrx/store';
import { selectIsEaglesoftPms, selectProvisionalLocksEditing } from '@libs/store';
import { isLockedByProvisional } from '@libs/utils';
import { HealthHistoryItemIconComponent } from '../health-history-item-icon/health-history-item-icon.component';
import { HealthHistoryItemVM } from '../health-history-item/health-history-item.component';
import { HealthHistoryItemProvisionalStatusIconComponent } from '../health-history-item-provisional-status-icon/health-history-item-provisional-status-icon.component';

@Component({
  selector: 'lib-health-history-item-details',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    TooltipModule,
    HealthHistoryItemIconComponent,
    TextWithShowMoreComponent,
    SvgIconComponent,
    HealthHistoryItemProvisionalStatusIconComponent,
  ],
  templateUrl: './health-history-item-details.component.html',
  styleUrl: './health-history-item-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HealthHistoryItemDetailsComponent {
  private readonly store = inject(Store);
  private readonly provisionalLocksEditing = this.store.selectSignal(selectProvisionalLocksEditing);
  protected readonly isEaglesoftPms = this.store.selectSignal(selectIsEaglesoftPms);

  public readonly healthHistoryItem = input.required<HealthHistoryItemVM>();
  public readonly hasEditButton = input<boolean>(true);
  public readonly editHealthHistoryEnabled = input<boolean>(true);
  public editButtonClicked = output<void>();

  public readonly isNotReady = computed(() => {
    return this.healthHistoryItem().provisionalStatus !== ProvisionalStatus.READY;
  });
  public readonly isUnderDeletion = computed(() => {
    return this.healthHistoryItem().provisionalStatus === ProvisionalStatus.DELETING;
  });
  public readonly isEditDisabled = computed(
    () =>
      isLockedByProvisional(this.healthHistoryItem().provisionalStatus, this.provisionalLocksEditing()) || !this.editHealthHistoryEnabled(),
  );

  public onEditButtonClick(): void {
    this.editButtonClicked.emit();
  }
}
